import { EasmBulkChangePropertyBaseDataProvider } from './EasmBulkChangePropertyBaseDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';

export abstract class EasmBulkChangeInvestigationPropertyDataProvider extends EasmBulkChangePropertyBaseDataProvider {
  public changeBulkProperty(
    findingIds: string[],
    value: any,
    updateRelatedArtifacts: boolean,
    note: string
  ): Promise<any> {
    return ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'EASMFindings',
      method: 'changeBulkInvestigationProperty',
      payload: {
        ids: findingIds,
        property: this.getApiInvestigationProperty(),
        value,
        updateRelatedArtifacts,
        note,
      },
    });
  }

  protected abstract getApiInvestigationProperty(): string;
}
